﻿export function setTitle(title) {
    document.title = title;
}

////setTitle = (title) => { document.title = title; };